<template>
  <div>
    <h1>Registration Form</h1>
    <registration-form />
  </div>
</template>

<script>
import RegistrationForm from '@/components/RegistrationForm.vue';

export default {
  metaInfo: {
    title: 'Registration',
  },
  components: {
    RegistrationForm,
  },
};
</script>

<style lang="scss" scoped>
  h1 {
    text-align: center;
  }

  @media (min-width: 1024px) {
    h1 {
      text-align: left;
    }
  }
</style>
